export default "__VITE_ASSET__DLn2SWMk__"